require('./draggableFile.styles');

import { SelectionDataStore } from 'sharebase-app/dataStores/selectionDataStore';
import { ActionService } from 'phoenix/services/actionService';
import { AppAction } from 'sharebase-app/components/_app/app.actions';
/**
 * @ngdoc directive
 * @name sharebase.directive:DraggableFileDirective
 * @module sharebase
 * @restrict A
 * @description
 *
 * `DraggableFileDirective` enables element to become a draggable element for file moving.
 *
 * @usage
 *
 * <sba-element sba-draggable-file="<criteria>" />
 *
 */
export function DraggableFileDirective(
	pxActionService: ActionService, 
	sbaSelectionDataStore: SelectionDataStore
): ng.IDirective {
	return {
		restrict: 'A',
		link: function(scope, element, attrs) {	

			scope.$watch(attrs.sbDraggableFile, (newVal, oldVal) => {
				if (angular.isDefined(newVal)) {
					attrs.$set('draggable', 'true');
					attrs.$set('drag-to-move', 'false');
				}
			});

			
			let selectedLength = 0;

			let uploadDisabled = element.hasClass('sba-drop-upload-disabled');

			let uiElm = angular.element('<div class="sb-draggable-file__dragging-count app-animate--scale-in app--background-red"></div>');

			function dragStart(e){
				e.dataTransfer.effectAllowed = 'move';
				e.dataTransfer.setData('text', attrs.sbDraggableFile);

				attrs.$set('drag-to-move', 'true');

				angular.element(document.querySelector('.sba__drop-upload-indicator')).addClass('sba__drop-upload-indicator-disabled');

				selectedLength = sbaSelectionDataStore.selectedItems.length;

				uiElm.text(selectedLength);

				if (selectedLength > 1) {
					element.append(uiElm);
				}

				uiElm.addClass('sb-dragging-count__show');

				uploadDisabled = angular.element(element).hasClass('sba-drop-upload-disabled');

				// Prevents element from dropping on themselves should they also be a dropzone.
				if (!uploadDisabled){
					element.addClass('sba-drop-upload-disabled');
				}
				pxActionService.emit({type: AppAction.DragToMove});

			}

			function dragEnd(e){
				// Clear up any unhandled styling.
				element.removeClass('sba-drop-upload-target---active');
				attrs.$set('drag-to-move', 'false');

				angular.element(document.querySelector('.sba__drop-upload-indicator')).removeClass('sba__drop-upload-indicator-disabled');

				if (!uploadDisabled){
					element.removeClass('sba-drop-upload-disabled');
				}

				uiElm.removeClass('sb-dragging-count__show');

				pxActionService.emit({type: AppAction.EndDrag});

			}



			// Add functionality on dragging the element.
			element[0].addEventListener('dragstart', dragStart);
			element[0].addEventListener('dragend', dragEnd);
			element.on('$destroy', function(e){
				element[0].removeEventListener('dragstart', dragStart);
				element[0].removeEventListener('dragend', dragEnd);
			});

		}
	}
}

DraggableFileDirective.$inject = [
	'pxActionService',
	'sbaSelectionDataStore'
];



// WEBPACK FOOTER //
// ./src/sharebase/components/draggableFile/draggableFile.ts